import React, { useCallback, useRef } from 'react';
import { View, Animated, StyleSheet } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { rem } from 'design-system/values';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
const TouchableBounceHighlight = ({ style, children, onPress, white }) => {
    const underlayOpacity = useRef(new Animated.Value(0));
    const onPressIn = useCallback(() => {
        Animated.spring(underlayOpacity.current, {
            toValue: 0.2,
            velocity: 0.1,
            bounciness: 0,
            useNativeDriver: true,
        }).start();
    }, []);
    const onPressOut = useCallback(() => {
        Animated.spring(underlayOpacity.current, {
            toValue: 0,
            velocity: 0.4,
            bounciness: 0,
            useNativeDriver: true,
        }).start();
    }, []);
    const styles = useStyles(styleSet);
    return (<TouchableBounce onPress={onPress} onPressIn={onPressIn} onPressOut={onPressOut}>
      <View style={style}>
        <Animated.View style={[{ opacity: underlayOpacity.current }, styles.underlay, white && styles.white]}/>
        {children}
      </View>
    </TouchableBounce>);
};
const styleSet = createStyleSheets((colors) => ({
    underlay: {
        ...StyleSheet.absoluteFillObject,
        borderRadius: rem(16),
        backgroundColor: colors.text.secondary,
    },
    white: {
        backgroundColor: colors.buttons.frosted,
    },
}));
export default TouchableBounceHighlight;
